export const getOutreachPlanData = (planMode, allPlans) =>
  allPlans.filter((plan) => plan.planMode === planMode && plan.id <= 82);

export const getInboxRadarPlanData = (planMode, allPlans) =>
  allPlans.filter(
    (plan) =>
      plan.planMode === planMode &&
      plan.id >= 520 &&
      plan.planCode !== 'demo-inbox-analyzer-pro-monthly-05-2025',
  );
